import React, { useEffect, useState } from "react";
import AddFeed from "../Components/Feed/AddFeedModal";
import { RefreshCw, Plus, Search, Edit2, Trash2 } from "lucide-react";
import { useSelector } from "react-redux";

import api from "../Utils/api";
import FeedMessage from "../Components/Feed/FeedMessage";
import Spinner from "../Components/Spinner";

const NewsFeed = () => {
  const user = useSelector((state) => state.user.user);

  const [activeTab, setActiveTab] = useState("all");
  const [isLoading, setIsLoading] = useState(false);
  const [newsfeeds, setNewsfeeds] = useState([]);

  const [openAddPostModal, setOpenAddPostModal] = useState(false);

  const tabs = [
    { id: "all", label: "All posts", icon: "📝" },
    { id: "important", label: "Important posts", icon: "⭐" },
    { id: "yours", label: "Your posts", icon: "📨" },
  ];

  const [locations, setLocations] = useState([]);

  useEffect(() => {
    getPosts();
    getLocations();
  }, []);

  const getPosts = async () => {
    setLocations(true);
    const res = await api.get("/newsfeed"); // Fetch posts from the API
    setLocations(false);
    if (res.data.success) {
      // console.log(res.data.newsfeeds);
      setNewsfeeds(res.data.newsfeeds); // Set the fetched posts to the state
      setFilteredFeedData(res.data.newsfeeds);
    }
  };

  const getLocations = async () => {
    try {
      setIsLoading(true);
      const response = await api.get("/location");
      setIsLoading(false);
      setLocations(response.data.locations);
    } catch (error) {
      console.error(error);
    }
  };

  const [searchLocation, setSearchLocation] = useState("");

  const filteredLocations =
    locations.length > 0 &&
    locations.filter((tab) =>
      tab.name.toLowerCase().includes(searchLocation.toLowerCase())
    );

  const closeAddFeed = () => {
    setOpenAddPostModal(false);
    getPosts();
  };

  const handleAddComment = () => {
    getPosts();
  };

  const [searchFeed, setSearchFeed] = useState("");
  const [filteredFeedData, setFilteredFeedData] = useState(newsfeeds);

  const handleFeedSearch = () => {
    const filtered = newsfeeds.filter(
      (feed) =>
        feed.content.toLowerCase().includes(searchFeed.toLowerCase()) ||
        feed.author.preferredName
          .toLowerCase()
          .includes(searchFeed.toLowerCase())
    );
    setFilteredFeedData(filtered);
  };

  const handleFeedKeyDown = (e) => {
    if (e.key === "Enter") {
      handleFeedSearch();
    }
  };

  const kindSearch = (value) => {
    setActiveTab(value);
    // console.log("Kind Search Value: ", value);
    let filtered = [];
    switch (value) {
      case "all":
        setFilteredFeedData(newsfeeds);
        break;
      case "yours":
        filtered = newsfeeds.filter((feed) => feed.author._id === user._id);
        setFilteredFeedData(filtered);
        break;
      case "important":
        filtered = newsfeeds.filter((feed) => feed.comments.length > 0);
        setFilteredFeedData(filtered);
        break;

      default:
        filtered = newsfeeds.filter((feed) => feed.location == value);
        setFilteredFeedData(filtered);
        break;
    }
  };

  return (
    <div className="pt-6 px-6 mt-10 mx-20">
      {isLoading && <Spinner />}

      {/* Page Content */}
      <div className="flex justify-between">
        <div className="flex flex-col justify-center">
          <h1 className="text-[32px] font-bold">News Feed</h1>
        </div>
        <div className="flex justify-between items-center gap-4">
          <div className="relative">
            <input
              type="text"
              placeholder="Search"
              className="w-full sm:w-80 border border-gray-300 rounded-md py-2 px-4 pl-10 focus:outline-none focus:ring-1 focus:ring-gray-200"
              value={searchFeed}
              onChange={(e) => setSearchFeed(e.target.value)}
              onKeyDown={handleFeedKeyDown}
            />
            <Search
              className="absolute left-3 top-2.5 text-gray-500"
              size={16}
            />
          </div>
          <button
            onClick={() => setOpenAddPostModal(true)}
            className="bg-gray-100 hover:bg-gray-200 text-gray-600 font-semibold px-4 py-2 rounded-md"
          >
            Create post
          </button>
        </div>
      </div>

      {/* <hr className="my-6" /> */}

      <div className="flex flex-col md:flex-row gap-8 mt-5">
        {/* Vertical Tabs Sidebar */}
        <aside className="md:w-1/6">
          <div className="mb-6">
            <div className="flex md:flex-col gap-2">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => kindSearch(tab.id)}
                  className={`flex text-left px-4 py-2 rounded-l-md text-sm font-medium transition
                  ${
                    activeTab === tab.id
                      ? "bg-gray-100 font-semibold border-r-[2px] border-gray-200"
                      : "hover:bg-gray-100"
                  }`}
                >
                  {tab.id === "all" && (
                    <svg
                      className="w-4"
                      focusable="false"
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      fill={`${activeTab === "all" ? "gray" : "#d8d7dc"}`}
                    >
                      <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M6 9h12v2H6zm8 5H6v-2h8zm4-6H6V6h12z" />
                    </svg>
                  )}
                  {tab.id === "important" && (
                    <svg
                      className="w-4"
                      focusable="false"
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      fill={`${activeTab === "important" ? "gray" : "#d8d7dc"}`}
                    >
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z" />
                    </svg>
                  )}
                  {tab.id === "yours" && (
                    <svg
                      className="w-4"
                      focusable="false"
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      fill={`${activeTab === "yours" ? "gray" : "#d8d7dc"}`}
                    >
                      <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M6 9h12v2H6zm8 5H6v-2h8zm4-6H6V6h12z" />
                    </svg>
                  )}
                  <span className="pl-2">{tab.label}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="w-full ">
            <h3 className="text-lg font-semibold mb-2">Locations</h3>
            <div className="w-full relative">
              <input
                type="text"
                placeholder="Search"
                className="w-full border border-gray-300 rounded-md py-1 px-4 pl-10 focus:outline-none focus:ring-1 focus:ring-gray-200"
                value={searchLocation}
                onChange={(e) => setSearchLocation(e.target.value)}
              />
              <Search
                className="absolute left-3 top-2.5 text-gray-500"
                size={16}
              />
            </div>
            <div className="flex md:flex-col max-h-[58vh] overflow-y-auto gap-2 mt-4">
              {filteredLocations.length > 0 &&
                filteredLocations.map((tab) => (
                  <button
                    key={tab._id}
                    onClick={() => kindSearch(tab._id)}
                    className={`flex text-left px-4 py-2 rounded-l-md text-sm font-medium transition
                  ${
                    activeTab === tab._id
                      ? "bg-gray-100 font-semibold border-r-[2px] border-gray-200"
                      : "hover:bg-gray-100"
                  }`}
                  >
                    <svg
                      className="w-4"
                      focusable="false"
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      fill={`${activeTab === tab._id ? "gray" : "#d8d7dc"}`}
                    >
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5" />
                    </svg>
                    <span className="pl-2">{tab.name}</span>
                  </button>
                ))}
            </div>
          </div>
        </aside>

        {/* Content Area Based on Tab */}
        <section className="flex-1 pl-4 max-h-[80vh] overflow-y-auto">
          {filteredFeedData.length > 0 &&
            filteredFeedData.map((feed, index) => (
              <FeedMessage
                key={index}
                {...feed}
                onDelete={() => getPosts()}
                postId={feed._id}
                onCommentAdded={handleAddComment}
              />
            ))}
        </section>

        <AddFeed isOpen={openAddPostModal} onClose={closeAddFeed} />
      </div>
    </div>
  );
};

export default NewsFeed;
